export function PasswordComplexityHint({ errors }) {
    if (!errors || errors.length === 0) return null;

    return (
        <div className="oct_password-complexity-hints">
            {errors.map((error, index) => (
                <span key={index} className="oct_password-complexity-hint-item">
                    ✗ {error}
                </span>
            ))}
        </div>
    );
}